(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apps-product-type-a"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    // タブに対してクリックイベントを適用
    const tabs = document.getElementsByClassName('tab');
    for(let i = 0; i < tabs.length; i++) {
      tabs[i].addEventListener('click', tabSwitch, false);
    }

    // タブをクリックすると実行する関数
    function tabSwitch(){
      // タブのclassの値を変更
      document.getElementsByClassName('is-active')[0].classList.remove('is-active');
      this.classList.add('is-active');
      // コンテンツのclassの値を変更
      document.getElementsByClassName('is-show')[0].classList.remove('is-show');
      const arrayTabs = Array.prototype.slice.call(tabs);
      const index = arrayTabs.indexOf(this);
      document.getElementsByClassName('panel')[index].classList.add('is-show');
    };
  }, false);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cloned-accr-prd-type-a"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const targetEl = document.querySelector('.cloned-accr-prd-type-a .Rte');
  const accordionsInProductMetaDescription = document.querySelectorAll('.ProductMeta__Description .acr_wrap');

  if (!accordionsInProductMetaDescription.length) return;

  accordionsInProductMetaDescription.forEach(function(accordion) {
    const clonedAccordion = accordion.cloneNode(true);
    clonedAccordion.classList.add('acr_wrap--cloned');

    if (clonedAccordion.querySelector('.acr_title').classList.contains('open')) {
      clonedAccordion.querySelector('.acr_title').classList.remove('open');
    }

    if (clonedAccordion.querySelector('.acr_cont').classList.contains('open')) {
      clonedAccordion.querySelector('.acr_cont').classList.remove('open');
    }

    targetEl.appendChild(clonedAccordion);
  });
});

  } catch(e) { console.error(e); }
})();
})();
